import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../../actions';

import Avatar from '../Avatar';
import DateTime from '../DateTime';

import { addFlashMessage } from '../../helpers/FlashMessages';

const UploadsListItem = ({
  profile,
  upload,
  openCollectionEditModal,
}) => {
  const intl = useIntl();

  return (
    <tr>
      <td className="upload-thumbnail file-image">
        <Link to={`/uploads/${upload.uuid}`} className="list-item-img-wrapper" target="_blank">
          <img
            id={`upload-img-${upload.uuid}`}
            className="list-item-img"
            width="100%"
            src={upload.thumbnail}
            alt=""
          />
        </Link>
      </td>
      {profile.is_admin && (
        <th scope="row" className="upload-user-name">
          <Avatar user={upload.user} />
          {upload.user.name}
        </th>
      )}
      <td className="upload-date">
        <DateTime
          id={`upload-date-${upload.uuid}`}
          dateTime={upload.created_at}
        />
      </td>
      <td className="upload-files">
        <Link to={`/uploads/${upload.uuid}`}>
          {upload.total_files}
        </Link>
      </td>
      <td className="action-more">
        <UncontrolledDropdown>
          <DropdownToggle nav className="options">
            <i className="far fa-ellipsis-h" />
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem
              onClick={() => {
                window.open(`/uploads/${upload.uuid}`);
              }}
            >
              <i className="fas fa-file" />
              {intl.formatMessage({ defaultMessage: 'View' })}
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem
              onClick={() => {
                openCollectionEditModal({
                  className: 'modal-edit-collection',
                  filesGroup: upload,
                  notificationCallback: (collection) => {
                    addFlashMessage({
                      type: 'success',
                      text: intl.formatMessage({ defaultMessage: 'A new Collection has been created' }),
                      button: {
                        url: `/collections/${collection.uuid}`,
                        text: intl.formatMessage({ defaultMessage: 'Open Collection' }),
                      },
                    });
                  },
                });
              }}
            >
              <i className="fas fa-clone" />
              {intl.formatMessage({ defaultMessage: 'Create Collection' })}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </td>
    </tr>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

const mapDispatchToProps = dispatch => ({
  openCollectionEditModal: (params) => {
    dispatch(showModal('CollectionEditModal', params));
  },
});

UploadsListItem.propTypes = {
  profile: PropTypes.object.isRequired,
  upload: PropTypes.object.isRequired,
  openCollectionEditModal: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadsListItem);
